/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaChoice from 'DesignSystem/TysiaChoice/index'
import TysiaChoiceText from 'DesignSystem/TysiaChoice/TysiaChoiceText/index'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/Gender/Choice",
  onChange
  
}) {
let optionIdValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let appointmentOverlayPatientNewPersonGenderChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.gender',
})
let optionItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'option_item',
path: 'isFirst',
})
let optionItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'option_item',
path: 'isLast',
})
let optionIsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isSelected',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let optionIsSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isSelected',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaChoice
  viewPath={`${viewPath}/TysiaChoice`}
 marginTop={0}
 width={32}
 height={24}
 borderTopRightRadius={optionItemIsLastValueData ? dtSpaceXxs : "0px"}
 borderBottomRightRadius={optionItemIsLastValueData ? dtSpaceXxs : "0px"}
 borderTopLeftRadius={optionItemIsFirstValueData ? dtSpaceXxs : "0px"}
 borderBottomLeftRadius={optionItemIsFirstValueData ? dtSpaceXxs : "0px"}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 paddingTop={dtSpaceXxs}
 backgroundColor={optionIsSelectedValueData ? dtColorsGreen700 : dtColorsWhite}
 borderColor={dtColorsNeutral300}
 borderWidth={1}
 alignItems="center"
 justifyContent="center"
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.isSelected" : "option.id"}
 id={optionIdValueData}
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.isSelected" : "appointment_overlay.patient_new.person.gender"}
 onClick={appointmentOverlayPatientNewPersonGenderChangeData}
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.isSelected" : "option_item.isFirst"}
>
{childProps => (
<TysiaChoiceText
{...childProps}
  viewPath={`${viewPath}/TysiaChoiceText`}
 data="option.text"
 text={optionTextValueData}
 color={optionIsSelectedValueData1 ? dtColorsWhite : dtColorsNeutral900}
 data="option.isSelected"
/>
)}
</TysiaChoice>
{children}
</React.Fragment>)
}